export const defaultRoles = {
  admin: {
    name: 'admin',
    explain: 'defines.admin',
    id: 100,
  },
  agency: {
    name: 'agency',
    explain: 'defines.agency',
    id: 101,
    installerLevel: 100,
    agencyLevel: 1,
    agencyMAXLevel: 5,
  },
  user: {
    name: 'user',
    explain: 'defines.user',
    id: 102,
  },
};

export const defaultRolesWithInstaller = {
  admin: {
    name: 'admin',
    explain: 'defines.admin',
  },
  agency: {
    name: 'agency',
    explain: 'defines.agency',
  },
  installer: {
    name: 'installer',
    explain: 'defines.installer',
    installerLevel: 100,
  },
  user: {
    name: 'user',
    explain: 'defines.user',
  },
};

export const validDesc = {
  valid: {
    explain: '有效',
    val: true,
  },
  invalid: {
    explain: '无效或注销',
    val: false,
  },
};

export const deviceTypes = {
  gateway: {
    val: 'gateway',
    explain: 'defines.gateway',
  },
  microInverter: {
    val: 'microInverter',
    explain: 'defines.inverter',
  },
  pcs: {
    val: 'pcs',
    explain: 'defines.pcs',
  },
  meter: {
    val: 'meter',
    explain: 'defines.meter',
  },
};

export const pcsEventType = {
  Error1: {
    val: 'Error1',
  },
  Error2: {
    val: 'Error2',
  },
  Error3: {
    val: 'Error3',
  },
  BmsAlarmExtension: {
    val: 'BmsAlarmExtension',
  },
  BmsErrorExtension: {
    val: 'BmsErrorExtension',
  },
  BmsFaultExtension: {
    val: 'BmsFaultExtension',
  },
};

export const defaultDeviceStatus = {
  inFactory: {
    val: 'inFactory',
    explain: 'defines.notDelivered',
  },
  outFactory: {
    val: 'outFactory',
    explain: 'defines.leaveTheFactory',
  },
  inService: {
    val: 'inService',
    explain: 'defines.installed',
  },
  inMaintenance: {
    val: 'inMaintenance',
    explain: 'defines.underMaintenance',
  },
  scraped: {
    val: 'scraped',
    explain: 'defines.scrap',
  },
};

export const defaultPlantStatus = {
  online: {
    val: 'online',
    explain: 'defines.online',
  },
  faulty: {
    val: 'faulty',
    explain: 'defines.faulty',
  },
  offline: {
    val: 'offline',
    explain: 'defines.offline',
  },
};

export const defaultStatus = {
  0: {
    val: 0,
    explain: 'defines.undisposed',
  },
  1: {
    val: 1,
    explain: 'defines.dispose',
  },
  2: {
    val: 2,
    explain: 'defines.unrecovered',
  },
};

export const defaultAlertLevels = {
  0: {
    val: 0,
    explain: 'defines.hint',
  },
  1: {
    val: 1,
    explain: 'defines.warning',
  },
  2: {
    val: 2,
    explain: 'defines.error',
  },
  3: {
    val: 3,
    explain: 'defines.fatal',
  },
};

export const defaultEmailPush = {
  true: {
    val: true,
    explain: 'common.yes',
  },
  false: {
    val: false,
    explain: 'common.no',
  },
};

export const defaultDeviceWorkingStatus = {
  online: {
    val: 'online',
    explain: 'defines.online',
  },
  faulty: {
    val: 'faulty',
    explain: 'defines.faulty',
  },
  offline: {
    val: 'offline',
    explain: 'defines.offline',
  },
};

export const defaultAgencyData = {
  1: {
    val: 1,
    explain: 'user.primaryAgent',
  },
  2: {
    val: 2,
    explain: 'user.secondaryAgent',
  },
  3: {
    val: 3,
    explain: 'user.thirdLevelAgent',
  },
  4: {
    val: 4,
    explain: 'user.fourthLevelAgent',
  },
  5: {
    val: 5,
    explain: 'user.fifthLevelAgent',
  },
  100: {
    val: 100,
    explain: 'user.installer',
  },
};

export const otaStatus = {
  toBePushed: {
    val: 'toBePushed',
    explain: '待推送，设备离线等原因',
  },
  pushed: {
    val: 'pushed',
    explain: '已下发升级，未收到响应',
  },
  upgrading: {
    val: 'upgrading',
    explain: '升级中',
  },
  success: {
    val: 'success',
    explain: '升级成功',
  },
  failur: {
    val: 'failure',
    explain: '升级失败',
  },
  cancelled: {
    val: 'cancelled',
    explain: '已取消',
  },
  timeout: {
    val: 'timeout',
    explain: '升级超时',
  },
  doing() {
    return [this.toBePushed.val, this.pushed.val, this.upgrading.val];
  },
};

export const defaultOtaModeData = {
  all: {
    val: 0,
    explain: 'defines.otaModeAll',
  },
  single: {
    val: 1,
    explain: 'defines.otaModeSingle',
  },
  batch: {
    val: 2,
    explain: 'defines.otaModeBathch',
  },
};

export const defaultCldUpdPeriodData = {
  300: {
    val: 5 * 60,
    explain: 'defines.minutes5',
  },
  600: {
    val: 10 * 60,
    explain: 'defines.minutes10',
  },
  900: {
    val: 15 * 60,
    explain: 'defines.minutes15',
  },
};

export const defaultPcsFwTypeData = {
  DSP1: {
    val: 'DSP1',
  },
  DSP2: {
    val: 'DSP2',
  },
  EMS: {
    val: 'EMS',
  },
  BMS: {
    val: 'BMS',
  },
};

export const defaultModuleData = {
  'msg.PVInfo.Vdc': {
    val: 'msg.PVInfo.Vdc',
    explain: 'defines.Vdc',
    unit: 'common.v',
    type: 'number',
  },
  'msg.PVInfo.Idc': {
    val: 'msg.PVInfo.Idc',
    explain: 'defines.Idc',
    unit: 'common.a',
    type: 'number',
  },
  'msg.PVInfo.Pdc': {
    val: 'msg.PVInfo.Pdc',
    explain: 'defines.Pdc',
    unit: 'common.w',
    type: 'number',
  },
  'msg.ACInfo.Vac': {
    val: 'msg.ACInfo.Vac',
    explain: 'defines.Vac',
    unit: 'common.v',
  },
  'msg.ACInfo.Pac': {
    val: 'msg.ACInfo.Pac',
    explain: 'defines.Pac',
    unit: 'common.w',
  },
  'msg.ACInfo.Qac': {
    val: 'msg.ACInfo.Qac',
    explain: 'defines.Qac',
    unit: 'common.var',
  },
  'msg.ACInfo.PFac': {
    val: 'msg.ACInfo.PFac',
    explain: 'defines.PFac',
    unit: 'common.percentSign',
  },
  'msg.ACInfo.Fac': {
    val: 'msg.ACInfo.Fac',
    explain: 'defines.Fac',
    unit: 'common.hz',
  },
  'msg.ACInfo.Sac': {
    val: 'msg.ACInfo.Sac',
    explain: 'defines.Sac',
    unit: 'common.va',
  },
  'msg.ACInfo.TPac': {
    val: 'msg.ACInfo.TPac',
    explain: 'defines.TPac',
    unit: 'common.w',
  },
  'msg.ACInfo.TQac': {
    val: 'msg.ACInfo.TQac',
    explain: 'defines.TQac',
    unit: 'common.var',
  },
  'msg.ACInfo.TSac': {
    val: 'msg.ACInfo.TSac',
    explain: 'defines.TSac',
    unit: 'common.va',
  },
  'msg.ACInfo.TPFac': {
    val: 'msg.ACInfo.TPFac',
    explain: 'defines.TPFac',
    unit: 'common.percentSign',
  },
  'msg.TempInfo.Tc': {
    val: 'msg.TempInfo.Tc',
    explain: 'defines.Tc',
    unit: 'common.celsiusDegree',
  },
  'msg.TempInfo.Tpv': {
    val: 'msg.TempInfo.Tpv',
    explain: 'defines.Tpv',
    unit: 'common.celsiusDegree',
  },
  'msg.TempInfo.Tinv': {
    val: 'msg.TempInfo.Tinv',
    explain: 'defines.Tinv',
    unit: 'common.celsiusDegree',
  },
  'msg.TempInfo.Tbat': {
    val: 'msg.TempInfo.Tbat',
    explain: 'defines.Tbat',
    unit: 'common.celsiusDegree',
  },
  'msg.EnergyInfo.EgridOutA': {
    val: 'msg.EnergyInfo.EgridOutA',
    explain: 'defines.EgridOutA',
    unit: 'common.kwh',
  },
  'msg.EnergyInfo.EgridInA': {
    val: 'msg.EnergyInfo.EgridInA',
    explain: 'defines.EgridInA',
    unit: 'common.kwh',
  },
  'msg.EnergyInfo.EqGridOutA': {
    val: 'msg.EnergyInfo.EqGridOutA',
    explain: 'defines.EqGridOutA',
    unit: 'common.kVarh',
  },
  'msg.EnergyInfo.EqGridInA': {
    val: 'msg.EnergyInfo.EqGridInA',
    explain: 'defines.EqGridInA',
    unit: 'common.kVarh',
  },
  'msg.EnergyInfo.EepsOutA': {
    val: 'msg.EnergyInfo.EepsOutA',
    explain: 'defines.EepsOutA',
    unit: 'common.kwh',
  },
  'msg.EnergyInfo.TEgridOutA': {
    val: 'msg.EnergyInfo.TEgridOutA',
    explain: 'defines.TEgridOutA',
    unit: 'common.kwh',
  },
  'msg.EnergyInfo.TEgridInA': {
    val: 'msg.EnergyInfo.TEgridInA',
    explain: 'defines.TEgridInA',
    unit: 'common.kwh',
  },
  'msg.EnergyInfo.TEqGridOutA': {
    val: 'msg.EnergyInfo.TEqGridOutA',
    explain: 'defines.TEqGridOutA',
    unit: 'common.kVarh',
  },
  'msg.EnergyInfo.TEqGridInA': {
    val: 'msg.EnergyInfo.TEqGridInA',
    explain: 'defines.TEqGridInA',
    unit: 'common.kVarh',
  },
  'msg.EnergyInfo.TEepsOutA': {
    val: 'msg.EnergyInfo.TEepsOutA',
    explain: 'defines.TEepsOutA',
    unit: 'common.kwh',
  },
  'msg.EnergyInfo.EpvA': {
    val: 'msg.EnergyInfo.c',
    explain: 'defines.EpvA',
    unit: 'common.kwh',
  },
  'msg.EnergyInfo.EbatOutA': {
    val: 'msg.EnergyInfo.EbatOutA',
    explain: 'defines.EbatOutA',
    unit: 'common.kwh',
  },
  'msg.EnergyInfo.EbatInA': {
    val: 'msg.EnergyInfo.EbatInA',
    explain: 'defines.EbatInA',
    unit: 'common.kwh',
  },
  'msg.StateInfo.StRuntime': {
    val: 'msg.StateInfo.StRuntime',
    explain: 'defines.StRuntime',
    unit: 'common.second',
  },
};

export const defaultReportColumns = {
  Vdc: {
    val: 'Vdc',
    explain: 'defines.Vdc',
    unit: 'common.v',
    type: 'number',
  },
  Idc: {
    val: 'Idc',
    explain: 'defines.Idc',
    unit: 'common.a',
    type: 'number',
  },
  Pdc: {
    val: 'Pdc',
    explain: 'defines.Pdc',
    unit: 'common.w',
    type: 'number',
  },
  Vac: {
    val: 'Vac',
    explain: 'defines.Vac',
    unit: 'common.v',
  },
  Pac: {
    val: 'Pac',
    explain: 'defines.Pac',
    unit: 'common.w',
  },
  Qac: {
    val: 'Qac',
    explain: 'defines.Qac',
    unit: 'common.var',
  },
  PFac: {
    val: 'PFac',
    explain: 'defines.PFac',
    unit: 'common.percentSign',
  },
  Fac: {
    val: 'Fac',
    explain: 'defines.Fac',
    unit: 'common.hz',
  },
  Sac: {
    val: 'Sac',
    explain: 'defines.Sac',
    unit: 'common.va',
  },
  TPac: {
    val: 'TPac',
    explain: 'defines.TPac',
    unit: 'common.w',
  },
  TQac: {
    val: 'TQac',
    explain: 'defines.TQac',
    unit: 'common.var',
  },
  TSac: {
    val: 'TSac',
    explain: 'defines.TSac',
    unit: 'common.va',
  },
  TPFac: {
    val: 'TPFac',
    explain: 'defines.TPFac',
    unit: 'common.percentSign',
  },
  Tc: {
    val: 'Tc',
    explain: 'defines.Tc',
    unit: 'common.celsiusDegree',
  },
  Tpv: {
    val: 'Tpv',
    explain: 'defines.Tpv',
    unit: 'common.celsiusDegree',
  },
  Tinv: {
    val: 'Tinv',
    explain: 'defines.Tinv',
    unit: 'common.celsiusDegree',
  },
  Tbat: {
    val: 'Tbat',
    explain: 'defines.Tbat',
    unit: 'common.celsiusDegree',
  },
  EgridOutA: {
    val: 'EgridOutA',
    explain: 'defines.EgridOutA',
    unit: 'common.kwh',
  },
  EgridInA: {
    val: 'EgridInA',
    explain: 'defines.EgridInA',
    unit: 'common.kwh',
  },
  EqGridOutA: {
    val: 'EqGridOutA',
    explain: 'defines.EqGridOutA',
    unit: 'common.kVarh',
  },
  EqGridInA: {
    val: 'EqGridInA',
    explain: 'defines.EqGridInA',
    unit: 'common.kVarh',
  },
  EepsOutA: {
    val: 'EepsOutA',
    explain: 'defines.EepsOutA',
    unit: 'common.kwh',
  },
  TEgridOutA: {
    val: 'TEgridOutA',
    explain: 'defines.TEgridOutA',
    unit: 'common.kwh',
  },
  TEgridInA: {
    val: 'TEgridInA',
    explain: 'defines.TEgridInA',
    unit: 'common.kwh',
  },
  TEqGridOutA: {
    val: 'TEqGridOutA',
    explain: 'defines.TEqGridOutA',
    unit: 'common.kVarh',
  },
  TEqGridInA: {
    val: 'TEqGridInA',
    explain: 'defines.TEqGridInA',
    unit: 'common.kVarh',
  },
  TEepsOutA: {
    val: 'TEepsOutA',
    explain: 'defines.TEepsOutA',
    unit: 'common.kwh',
  },
  EpvA: {
    val: 'EpvA',
    explain: 'defines.EpvA',
    unit: 'common.kwh',
    decimal: 2,
  },
  EbatOutA: {
    val: 'EbatOutA',
    explain: 'defines.EbatOutA',
    unit: 'common.kwh',
  },
  EbatInA: {
    val: 'EbatInA',
    explain: 'defines.EbatInA',
    unit: 'common.kwh',
  },
  StWork: {
    val: 'StWork',
    explain: 'defines.StWork',
    unit: '',
  },
  StMode: {
    val: 'StMode',
    explain: 'defines.StMode',
    unit: '',
  },
  StFunc: {
    val: 'StFunc',
    explain: 'defines.StFunc',
    unit: '',
  },
  StError: {
    val: 'StError',
    explain: 'defines.StError',
    unit: '',
  },
  StRuntime: {
    val: 'StRuntime',
    explain: 'defines.StRuntime',
    unit: 'common.second',
  },
};

export const defaultCurrencyData = {
  EUR: {
    val: 'EUR',
    symbol: '€',
    name: 'currency.Euro',
  },
  USD: {
    val: 'USD',
    symbol: '$',
    name: 'currency.USD',
  },
  CNY: {
    val: 'CNY',
    symbol: '￥',
    name: 'currency.RMB',
  },
  GBP: {
    val: 'GBP',
    symbol: '£',
    name: 'currency.GBP',
  },
  AUD: {
    val: 'AUD',
    symbol: 'A$',
    name: 'currency.AUD',
  },
  INR: {
    val: 'INR',
    symbol: '₹',
    name: 'currency.INR',
  },
  NZD: {
    val: 'NZD',
    symbol: 'NZ$',
    name: 'currency.NZD',
  },
  THB: {
    val: 'THB',
    symbol: '฿',
    name: 'currency.THB',
  },
  BRL: {
    val: 'BRL',
    symbol: 'r$',
    name: 'currency.BRL',
  },
  PLN: {
    val: 'PLN',
    symbol: 'zł',
    name: 'currency.PLN',
  },
  PHP: {
    val: 'PHP',
    symbol: '₱',
    name: 'currency.PHP',
  },
};

export const defaultInstructsType = {
  C002: {
    val: 'C002',
    explain: 'C002',
  },
  C003: {
    val: 'C003',
    explain: 'C003',
  },
  C005: {
    val: 'C005',
    explain: 'C005',
  },
  C010: {
    val: 'C010',
    explain: 'C010',
  },
};
